<div class="login-card trusted-card">
  <div class="trusted-icon" aria-hidden="true">
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#edc99e" stroke-width="1.6"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  </div>

  <span class="trusted-title">Welcome back{{ restore.name ? ', ' + restore.name : '' }}</span>
  <span class="trusted-subtitle">
    This browser is linked to the account below. Continue with this account, or use a different one.
  </span>

  @if (restore.familyCode) {
  <div class="primary-device-chip">
    <span class="chip-phone-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </span>
    <div class="chip-text">
      <span class="chip-label">Family code</span>
      <span class="chip-name">{{ restore.familyCode }}</span>
    </div>
  </div>
  }

  @if (restore.error) {
  <small class="error-text" style="text-align: center">{{ restore.error }}</small>
  }

  <div class="trusted-actions">
    <button class="verify-btn" [disabled]="restore.loadingAction !== null" (click)="restored.emit()">
      @if (restore.loadingAction === 'restore') {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else { Continue as {{ restore.name || 'this account' }} }
    </button>

    <button class="untrusted-btn" [disabled]="restore.loadingAction !== null" (click)="accountSwitched.emit()">
      @if (restore.loadingAction === 'revoke') {
      <span class="spinner spinner-light" role="status" aria-label="Loading"></span>
      } @else { Use another account }
    </button>
  </div>

  <span class="trusted-note">
    Choosing another account will unlink this browser from the account above.
  </span>
</div>
